import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { mockData } from '../mock';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="network-header">
      <div className="nav-wrapper">
        {/* <div className="network-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_guargum-central/artifacts/twynfr4y_Screenshot%202025-09-29%20111936.png" 
            alt="GreenZaar Logo" 
            className="logo-img"
          />
        </div> */
        <img 
      src={`${process.env.PUBLIC_URL}/greenzaar-logo.png`} 
      alt="GreenZaar Logo" 
      className="logo-img"
       />
        }
        
        {/* Desktop Navigation */}
        <nav className="network-nav hidden md:flex">
          {mockData.navigation.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="network-nav-link"
            >
              {item.name}
            </a>
          ))}
        </nav>
        
        {/* CTA Button */}
        <div className="hidden md:block">
          <a href="#contact" className="btn-primary">
            Get Quote
          </a>
        </div>
        
        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t-2 border-gray-100 mt-2 rounded-lg mx-4">
          <nav className="flex flex-col p-4">
            {mockData.navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="py-3 text-gray-700 hover:text-green-700 font-medium border-b border-gray-100 last:border-b-0"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </a>
            ))}
            <a href="#contact" className="btn-primary mt-4 text-center">
              Get Quote
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

// Network Header Styles
const styles = `
.network-header {
  background: var(--bg-page);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99999;
  padding: 16px 12px;
  height: 80px;
}

.nav-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  background: var(--brand-dark);
  border-radius: 25px;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 69, 52, 0.25);
  height: 64px;
}

.network-logo {
  font-size: 18px;
  font-weight: 600;
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.logo-img {
  height: 48px;
  width: auto;
  background: white;
  border-radius: 8px;
  padding: 6px;
}

.network-nav {
  display: flex;
  align-items: center;
  gap: 24px;
}

.network-nav-link {
  color: white;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 20px;
  transition: all 0.2s ease;
}

.network-nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 781px) {
  .network-header {
    top: 0;
    position: fixed;
  }
  
  .nav-wrapper {
    border-radius: 0;
    padding: 16px;
  }
  
  .network-nav {
    display: none;
  }
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}